var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectificationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_sync-alt",
    "data-name": "solid sync-alt",
    d: "M22.626,13.052a6.776,6.776,0,0,0-11.2,3.289.485.485,0,0,1-.47.369H8.649a.484.484,0,0,1-.476-.572A10,10,0,0,1,24.908,10.77l1.44-1.44A.968.968,0,0,1,28,10.014v5.406a.968.968,0,0,1-.968.968H21.627a.968.968,0,0,1-.684-1.652ZM8.968,19.613h5.406a.968.968,0,0,1,.684,1.652l-1.683,1.683a6.776,6.776,0,0,0,11.2-3.289.485.485,0,0,1,.47-.369h2.311a.484.484,0,0,1,.476.572A10,10,0,0,1,11.092,25.23l-1.44,1.44A.968.968,0,0,1,8,25.986V20.581A.968.968,0,0,1,8.968,19.613Z",
    transform: "translate(-8 -8)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectificationsIcon);
export default __webpack_public_path__ + "static/media/rectifications-icon.66435de2487373c47ee2ef3a0ca84795.svg";
export { ForwardRef as ReactComponent };